module.exports = __webpack_public_path__ + "static/media/the-game-aflw-2025-national.ffc58c33.png";